<template>
  <div>
    <div
      class="meetingType-filter-block"
      :style="`margin-left: ${meetingTypeFilterPosLeft}px; padding-top: 6px;`"
    >
      <agenda-meeting-type-filter v-model="selectedMeetingTypes" :height="35" />
    </div>
    <v-card :height="schedulerHeight" elevation="0">
      <div id="SchedulerParent" style="height: 100%">
        <ejs-schedule
          height="100%"
          :locale="locale"
          cssClass="agenda-scheduler"
          id="agendaSchedule"
          ref="agendaScheduleObj"
          width="100%"
          :allowMultiCellSelection="false"
          :selectedDate="selectedDate"
          :rowAutoHeight="true"
          :eventSettings="eventSettings"
          :renderCell="onRenderCell"
          :group="groupSettings"
          :eventRendered="onEventRendered"
          :quickInfoTemplates="quickInfoTemplates"
          :moreEventsClick="moreEventsClick"
          :cellClick="onCellClick"
          :cellDoubleClick="onCellDoubleClick"
          :popupOpen="onPopupOpen"
          :drag="onDrag"
          :allowDragAndDrop="false"
          :dataBound="onDataBound"
          :navigating="navigate"
          :firstMonthOfYear="firstMonthOfYear"
          :actionBegin="onActionBegin"
        >
          <!-- Template for Appointment -->
          <template v-slot:eventTemplate="{ data }">
            <v-card
              :id="data.StartTime"
              @click="
                $router.push(`/meeting/${data.id}/agenda/tenant/${tenantId}`)
              "
              class="subject appointment-meeting-template full-width"
              tile
            >
              <v-row no-gutters class="appointment-meetingName pl-2 pr-2">
                {{ data.meetingName }}
              </v-row>
              <v-row
                no-gutters
                class="appointment-topic px-1 ma-1"
                v-for="(topicCat, index) in data.topicCategory"
                :key="index"
              >
                <v-col cols="12" class="topic-category text-center">{{
                  topicCat.name
                }}</v-col>
                <ul class="pl-4" style="width: 100%">
                  <li v-for="(topic, index) in topicCat.topics" :key="index">
                    <span class="topic">{{ topic.topicName }}</span>
                    <v-divider
                      v-if="index !== topicCat.topics.length - 1"
                    ></v-divider>
                  </li>
                </ul>
              </v-row>
            </v-card>
          </template>

          <!-- Template for Tooltip of Appointment -->
          <template v-slot:tooltipTemplate="{ data }">
            <div
              class="tooltip-wrap e-schedule-event-tooltip"
              style="min-width: 160px"
            >
              <div>
                {{ data.meetingName }}
              </div>
              <div>
                {{ data.Location }}
              </div>
              <div>
                {{ data.meetingType }}
              </div>
              <v-row no-gutters>
                <v-col cols="5">
                  <span
                    class="text-subtitle-1 font-weight-bold primary--text"
                    v-html="
                      getMeetingScheduleDetails(data.scheduletStartTimeInUTC)
                    "
                  ></span>
                </v-col>
                <v-col cols="2" class="d-flex align-center justify-center">
                  <span class="font-weight-bold" style="font-size: 21px"
                    >-</span
                  >
                </v-col>
                <v-col cols="5">
                  <span
                    class="text-subtitle-1 font-weight-bold primary--text"
                    v-html="
                      getMeetingScheduleDetails(data.scheduledEndTimeInUTC)
                    "
                  ></span>
                </v-col>
              </v-row>
            </div>
          </template>

          <e-views>
            <e-view
              option="TimelineYear"
              displayName="Vertical Timeline Year"
              orientation="Vertical"
            ></e-view>
          </e-views>
          <e-resources>
            <e-resource
              field="agenda_category_id"
              title="Agenda category"
              name="AgendaCategory"
              :allowMultiple="true"
              :dataSource="getAgendaCategory"
              textField="name"
              idField="id"
              colorField="color"
            ></e-resource>
            <e-resource
              field="agenda_id"
              title="Agenda"
              name="Agenda"
              :allowMultiple="true"
              :dataSource="getAgendas"
              textField="agendaName"
              idField="id"
              groupIDField="agendaCategoryId"
            ></e-resource>
          </e-resources>
        </ejs-schedule>
      </div>
    </v-card>
    <Loader :loading="loading" :message="LoaderText"></Loader>
  </div>
</template>

<script>
import Vue from "vue";
import Loader from "@/components/Loader.vue";
import AgendaMeetingTypeFilter from "./AgendaMeetingTypeFilter.vue";
import { SchedulePlugin, TimelineYear } from "@syncfusion/ej2-vue-schedule";
import * as localeText from "@/Langs/locale.json";
import { extend, loadCldr, L10n, setCulture } from "@syncfusion/ej2-base";
import { mapGetters, mapState, mapActions } from "vuex";
import { getDateRange } from "../../utils/util";
loadCldr(
  require("cldr-data/supplemental/numberingSystems.json"),
  require("cldr-data/main/ja/ca-gregorian.json"),
  require("cldr-data/main/ja/numbers.json"),
  require("cldr-data/main/ja/timeZoneNames.json")
);
Vue.use(SchedulePlugin);
L10n.load(localeText.default);
export default {
  name: "AgendaViewSchedule",
  components: { Loader, AgendaMeetingTypeFilter },
  props: {
    schedulerHeight: Number,
    agendaCategoryData: {
      type: Array,
      default: () => [],
    },
    agendaData: {
      type: Array,
      default: () => [],
    },
    meetingList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedDate: new Date(),
      groupSettings: {
        byGroupID: true,
        resources: ["AgendaCategory", "Agenda"],
      },
      lastScrollTop: 0,
      lastScrollLeft: 0,
      scrollHandler: null,
      topicCategoryList: [],
      cell: null,
      resizing: true,
      heightClassNames: [],
      monthTable: null,
      currentYear: new Date().getFullYear(),
      loading: false,
      selectedMeetingTypes: [],
      meetingTypeFilterPosLeft: 345,
      savedHorizontalScrollLeft: 0,
      savedVerticalScrollTop: 0,
      isLastPage: false,
    };
  },
  provide: {
    schedule: [TimelineYear],
  },
  watch: {
    getAgendas(newVal) {
      if (Array.isArray(newVal) && newVal.length > 0 && newVal.length % 15 !== 0) {
        this.isLastPage = true;
      }
    }
  },
  created() {
    this.topicCategoryList = this.tenantSettingTypes("topiccategory");
    let date =
      new Date(
        new Date(this.selectedDate).getFullYear(),
        this.getFirstMonthOfYear,
        1
      ) || new Date();
    let dates = getDateRange(date);
    localStorage.setItem(
      `currentAgendaUIYear#${sessionStorage.getItem("tenantId")}`,
      JSON.stringify(dates)
    );
  },
  beforeDestroy() {
    if (this.monthTable && this.monthTable.length) {
      this.monthTable[0]?.removeEventListener("scroll", this.scrolled());
    }
  },
  computed: {
    ...mapGetters({
      tenantSettingTypes: "tenant/tenantSettingTypes",
    }),
    ...mapState({
      getFirstMonthOfYear: (state) => state.agenda.firstMonthOfYear,
    }),
    LoaderText() {
      return this.$t("LoaderText");
    },
    firstMonthOfYear: {
      get() {
        return this.getFirstMonthOfYear;
      },
      set(val) {
        this.setFirstMonthOfYear(val);
      },
    },
    getAgendaCategory() {
      return this.agendaCategoryData;
    },
    getAgendas() {
      return this.agendaData;
    },
    locale() {
      setCulture(this.$i18n.locale);
      return this.$i18n.locale;
    },
    eventSettings() {
      return {
        template: "eventTemplate",
        dataSource: extend([], this.meetingData, null, true),
        enableTooltip: true,
        tooltipTemplate: "tooltipTemplate",
      };
    },
    meetingData() {
      const list = this.filterMeetings(this.selectedMeetingTypes).map(
        (meeting) => ({
          ...meeting,
          Location: meeting.location,
          Subject: meeting.meetingName,
          StartTime: new Date(meeting.scheduletStartTimeInUTC),
          EndTime: new Date(meeting.scheduledEndTimeInUTC),
          meetingType: meeting.meetingType,
          Description: meeting.description,
          topicCategory: this.topicCategoryList
            .map((item) => ({
              ...item,
              topics: meeting.topics.filter(
                (s) =>
                  s.topicCategory === item.id &&
                  s.agendaId === meeting.agenda_id
              ),
            }))
            .filter((ca) => {
              return ca.topics.length > 0;
            }),
        })
      );
      return list;
    },
    selectedLang() {
      return this.$i18n.locale;
    },
    tenantId() {
      return sessionStorage.getItem("tenantId");
    },
  },
  methods: {
    setLastPageReached() {
      this.isLastPage = true;
    },
    ...mapActions({
      setFirstMonthOfYear: "agenda/setFirstMonthOfYear",
    }),
    filterMeetings(selectedMeetTypes) {
      if (selectedMeetTypes.length === 0) {
        return this.meetingList;
      } else {
        const selectedMeetingTypeLabels = selectedMeetTypes.map(
          (meetType) => meetType.label
        );
        return this.meetingList.filter((meeting) =>
          selectedMeetingTypeLabels.includes(meeting.meetingType)
        );
      }
    },
    changeFirstMonthOfYear(e) {
      this.firstMonthOfYear = parseInt(e.target?.value) || 0;
      e.target?.blur();
      let date =
        new Date(this.currentYear, this.getFirstMonthOfYear, 1) || new Date();
      let dates = getDateRange(date);
      localStorage.setItem(
        `currentAgendaUIYear#${sessionStorage.getItem("tenantId")}`,
        JSON.stringify(dates)
      );
      this.yearChanged(dates);
    },
    setMeetingTypePosition() {
      const monthSelectEl =
        document.getElementsByClassName("month-selection")[0];
      if (!monthSelectEl) return;

      const parentWidth = monthSelectEl.parentElement.clientWidth;
      const minWidth = this.firstMonthOfYear === 0 ? 248 : 345;
      this.meetingTypeFilterPosLeft =
        parentWidth >= minWidth ? parentWidth : minWidth;
    },
    onActionBegin(args) {
      if (args.requestType === "toolbarItemRendering") {
        let monthSelectionItem = {
          align: "left",
          name: "custom",
          cssClass: "month-selection",
          tooltipText: this.$t("agenda.tipSelectFirstMonthOfYear"),
          template: `<div class="e-tbar-btn month-selection-container" style='position: relative; display: inline-block'>
              <select id='monthSelect' name="months" class="month-select" :value='firstMonthOfYear'>
              </select>
            </div>`,
        };
        args.items[0].tooltipText = this.$t("agenda.tipPreviousYear");
        args.items[1].tooltipText = this.$t("agenda.tipNextYear");
        args.items[2].tooltipText = this.$t("agenda.tipYearlyAgendaDateRange");
        args.items.splice(3, 0, monthSelectionItem);
        args.items[4].visible = false;

        this.$nextTick(() => {
          const selectEl = document.getElementById("monthSelect");
          if (selectEl) {
            this.$t("month")?.forEach((month, index) => {
              const option = document.createElement("option");
              option.value = index;
              option.innerText = month;
              selectEl.appendChild(option);
            });
            selectEl.value = this.firstMonthOfYear;
            selectEl?.addEventListener("change", this.changeFirstMonthOfYear);
          }
          this.setMeetingTypePosition();
        });
      }
    },
    scrolled(table) {
      if (!table || this.loading || this.isLastPage) return;

      const { scrollLeft, scrollTop, scrollHeight, clientHeight } = table;
      const tolerance = 1;
      const totalScrollPosition = scrollTop + clientHeight;

      this.savedHorizontalScrollLeft = scrollLeft;
      this.savedVerticalScrollTop = scrollTop;

      const isAtBottom =
        Math.ceil(totalScrollPosition) >= scrollHeight ||
        Math.ceil(totalScrollPosition + tolerance) >= scrollHeight;

      const isVerticalScroll = scrollTop !== this.lastScrollTop;

      this.lastScrollTop = scrollTop;

      if (isAtBottom && isVerticalScroll) {
        this.loading = true;
        let dates = JSON.parse(
          localStorage.getItem(
            `currentAgendaUIYear#${sessionStorage.getItem("tenantId")}`
          )
        );
        let newDates = getDateRange(new Date());
        this.loadMoreData(
          dates?.from_year && dates?.to_year ? dates : newDates
        );
      }
    },
    onRefreshLayout() {
      let scheduleObj = this.$refs.agendaScheduleObj.ej2Instances;
      scheduleObj.refreshLayout();
      this.loading = false;
    },
    getMeetingScheduleDetails(scheduleTime) {
      const date = new Date(scheduleTime);
      const time = new Intl.DateTimeFormat(this.selectedLang, {
        timeStyle: "short",
      }).format(date);

      const d = date.getDate();
      const day = d < 10 ? `0${d}` : d;
      const m = date.getMonth() + 1; //Month from 0 to 11
      const month = m < 10 ? `0${m}` : m;
      const y = date.getFullYear();
      return `${y}/${month}/${day} <br> ${time}`;
    },
    loadMoreData(dates) {
      if (this.isLastPage) return;
      const obj = {
        offset: this.getAgendas.length,
        limit: 15,
        from_year: dates.from_year,
        to_year: dates.to_year,
      };
      this.$emit("loadMore", obj);
    },
    yearChanged(dates) {
      const obj = {
        offset: 0,
        limit: 15,
        from_year: dates.from_year,
        to_year: dates.to_year,
      };
      this.$emit("yearChange", obj);
    },
    onPopupOpen(event) {
      event.cancel = true;
    },
    moreEventsClick(event) {},
    quickInfoTemplates(event) {
      event.cancel = true;
    },
    onDrag(event) {
      event.cancel = true;
    },
    setAgendaUI() {
      this.loading = true;
      let monthHeaders;
      setTimeout(() => {
        let appointments = document.getElementsByClassName("meetingWrapper");
        let cells = document.getElementsByClassName("meetingCell");
        let agendaCells = document.getElementsByClassName("agendaResource");
        for (let c = 0; c < cells.length; c++) {
          let childrenHeight = 0;
          let cell = cells[c];
          for (let a = 0; a < appointments.length; a++) {
            let appointment = appointments[a];
            let appointmentDate = new Date(
              appointment.children[0].children[0].id
            );
            let cellDate = new Date(Number(cell.dataset.date));

            if (
              appointmentDate.getMonth() == cellDate.getMonth() &&
              appointmentDate.getFullYear() == cellDate.getFullYear() &&
              cell.dataset.groupIndex == appointment.dataset.groupIndex
            ) {
              childrenHeight += appointment.offsetHeight;
              this.addHeightClassOnElement(childrenHeight, cell);
              if (appointment.previousSibling == null) {
                appointment.style.top = `${cell.offsetTop}px`;
              } else {
                if (
                  appointment.previousSibling &&
                  appointment.parentNode.childElementCount
                ) {
                  for (
                    let i = 0;
                    i < appointment.parentNode.children.length;
                    i++
                  ) {
                    let sum = 0;
                    for (let j = 0; j < i; j++) {
                      sum += appointment.parentNode.children[j].offsetHeight;
                    }
                    appointment.parentNode.children[i].style.top = `${
                      cell.offsetTop + sum
                    }px`;
                    appointment.parentNode.style.position = "relative";
                  }
                }
              }
            } else {
              childrenHeight = 0;
            }
          }
          for (let i = 0; i < agendaCells.length; i++) {
            if (agendaCells[i].dataset.groupIndex == cell.dataset.groupIndex) {
              this.addHeightClassOnElement(cell.offsetHeight, agendaCells[i]);
            }
          }
        }
        this.resizing = false;
        monthHeaders = document.getElementsByClassName("e-header-cells");
        this.monthTable = document.getElementsByClassName("e-content-wrap");
      }, 0);
      setTimeout(() => {
        this.onRefreshLayout();

        if (this.monthTable && this.monthTable[0]) {
          this.monthTable[0].scrollLeft = this.savedHorizontalScrollLeft || 0;
          this.monthTable[0].scrollTop = this.savedVerticalScrollTop || 0;
          this.monthTable[0].addEventListener("scroll", () => {
            this.scrolled(this.monthTable[0]);
          });
        }
        let prevBtn = document.getElementsByClassName("e-prev");
        prevBtn[0].firstChild.title = this.$t("agenda.tipPreviousYear");
        let nextBtn = document.getElementsByClassName("e-next");
        nextBtn[0].firstChild.title = this.$t("agenda.tipNextYear");
        if (this.meetingData.length) this.loading = false;
      }, 100);
      if (!this.meetingData.length) this.loading = false;
    },
    navigate(args) {
      if (args.action === "date") {
        let date =
          new Date(
            new Date(args.currentDate).getFullYear(),
            this.getFirstMonthOfYear,
            1
          ) || new Date();
        this.currentYear = date.getFullYear();
        let dates = getDateRange(date);
        this.yearChanged(dates);
        localStorage.setItem(
          `currentAgendaUIYear#${sessionStorage.getItem("tenantId")}`,
          JSON.stringify(dates)
        );
      }
    },
    onDataBound() {
      this.setMeetingTypePosition();
      this.setAgendaUI();
    },
    onEventRendered(args) {
      args.element.style.backgroundColor = "#004c7a";
      if (args.element && args.element?.classList.contains("e-appointment")) {
        args.element.classList.add("meetingWrapper");
      }
    },
    onCellClick(event) {
      event.cancel = true;
    },
    onCellDoubleClick(event) {
      event.cancel = true;
    },
    onRenderCell(args) {
      // For agenda category
      if (
        args.element &&
        args.elementType === "resourceHeader" &&
        args.element?.classList.contains("e-parent-node")
      ) {
        args.element.classList.add("agendaCategoryResource");
        args.element.children[1].style.fontSize =
          args.element.children[1].className == "e-resource-text" ? "14px" : "";
        args.element.children[1].classList.add("agendaCategoryTooltip");
        args.element.children[1].title = `${this.$t(
          "agenda.tipAgendaCategoryName"
        )}: ${args.element.children[1].textContent}`;
      }
      // For agenda
      if (
        args.element &&
        args.elementType === "resourceHeader" &&
        args.element?.classList.contains("e-child-node")
      ) {
        args.element.classList.add("agendaResource");
        args.element.children[0].classList.add("agendaNameTooltip");
        args.element.children[0].title = `${this.$t("agenda.tipAgendaName")}: ${
          args.element.children[0].textContent
        }`;
      }
      // For header of agenda category and agenda
      if (
        args.element &&
        args.elementType === "emptyCells" &&
        args.element?.classList.contains("e-resource-left-td")
      ) {
        let target = args.element.querySelector(".e-resource-text");
        target.innerHTML = `<div class="agenda-category-header">${this.$t(
          "agenda.titleAgendaByCategory"
        )}</div>`;
      }
      // For cell
      if (
        args.element &&
        args.elementType === "resourceGroupCells" &&
        args.element?.classList.contains("e-work-days")
      ) {
        args.element.classList.add("meetingCell");
      }
    },
    addHeightClassOnElement,
  },
};

function addHeightClassOnElement(height, element) {
  height = element.classList.contains("agendaResource") ? height : height + 8;
  const className = `h-${height}px`;
  if (!this.heightClassNames.includes(className)) {
    this.heightClassNames.push(className);
    createHeightCssClass(className, height);
  }
  const classList = element.classList;
  const allClassesStartWithH = Array.from(classList).filter((className) =>
    className.startsWith("h-")
  );
  const numbers = allClassesStartWithH
    .map((className) => {
      const match = className.match(/^h-(\d+)px$/);
      return match ? parseInt(match[1], 10) : null;
    })
    .filter((number) => number !== null);

  const maxNumber = Math.max(...numbers);
  if (maxNumber < height) {
    element.classList.remove(`h-${maxNumber}px`);
    element.classList.add(`${className}`);
  }
}

function createHeightCssClass(name, number) {
  var style = document.createElement("style");
  style.type = "text/css";
  style.innerHTML = `.${name} { height: ${number}px !important; }`;
  document.getElementsByTagName("head")[0].appendChild(style);
}
</script>

<style scoped>
.meetingType-filter-block {
  position: absolute;
  z-index: 1;
}
.agenda-scheduler.e-schedule /deep/ .e-footer-container .e-btn.e-today {
  display: none;
}
.agenda-scheduler.e-schedule /deep/ .month-select {
  padding: 0 20px 0 8px;
  border-radius: 4px;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.87);
  font-family: "Noto Sans JP";
  font-size: 14px;
  width: 100%;
}
.agenda-scheduler.e-schedule /deep/ .month-selection-container:hover {
  background: inherit;
}
.agenda-scheduler.e-schedule /deep/ .month-selection-container {
  width: 100%;
  border-radius: 2px;
  padding: 0px !important;
}
.agenda-scheduler.e-schedule /deep/ .month-selection-container:focus-within {
  background: #cccccc;
}
.agenda-scheduler.e-schedule /deep/ .month-selection-container::after {
  content: "▼";
  top: 55%;
  right: 3px;
  position: absolute;
  color: rgba(0, 0, 0, 0.54);
  font-size: 7.5px;
  padding-right: 5px;
  transform: translateY(-50%) scaleX(1.6);
  pointer-events: none;
}
.agenda-scheduler.e-schedule /deep/ .month-selection {
  max-width: 110px;
}
.agendaCategoryTooltip,
.agendaNameTooltip {
  height: 3em;
  width: 10em;
}
/* For agenda name */
.agenda-scheduler.e-schedule /deep/ .agendaResource {
  padding-left: 5px;
  padding-right: 5px;
  align-items: start !important;
}
/* For agenda category name */
.agenda-scheduler.e-schedule /deep/ .agendaCategoryResource {
  padding-left: 5px;
  max-height: 35px;
  background-color: rgb(221, 221, 221);
  color: rgb(51, 51, 51);
  border-width: 1px 1px 1px 0px;
}
.agendaCategoryResource .e-resource-text {
  font-size: 14px !important;
}
.appointment-meeting-template {
  cursor: pointer;
  white-space: normal;
  margin: 3px 4px 2px;
  z-index: 1;
}
.appointment-topic {
  border-radius: 4px;
}
.topic-category {
  border: 1px solid #005c94;
  border-radius: 4px;
  color: #005c94;
  font-size: 13px !important;
  font-family: "Noto Sans JP" !important;
  font-weight: 400 !important;
}
.topic {
  font-family: "Noto Sans JP" !important;
  font-size: 12px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.appointment-meetingName {
  display: block;
  font-size: 13px !important;
  font-family: "Noto Sans JP" !important;
  color: white;
  background: #005c94;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.agenda-scheduler.e-schedule /deep/ .e-resource-text > div {
  flex: 0 0 100%;
  font-weight: 500;
  line-height: 30px;
  height: 30px;
  overflow: hidden;
  padding-left: 5px;
  text-overflow: ellipsis;
}
.agenda-scheduler /deep/ .agenda-category-header {
  color: #ffffff;
  font-family: "Noto Sans JP" !important;
  font-style: normal !important;
  font-size: 15px !important;
}
.agenda-scheduler.e-schedule /deep/ .e-resource-left-td {
  width: 200px;
  height: 40px;
  background-color: var(--v-neutralGray-base) !important;
  color: #ffffff;
  border-right: 1px solid #ffffff;
}
.agenda-scheduler.e-schedule /deep/ .e-date-header-wrap table col,
.agenda-scheduler.e-schedule /deep/ td .e-date-header-container td {
  font-family: "Noto Sans JP" !important;
  font-style: normal !important;
  font-size: 15px !important;
  min-width: 200px !important;
  height: 40px;
  background-color: var(--v-neutralGray-base);
  color: #ffffff;
  border-right: 1px solid #ffffff;
  font-weight: 500;
}
.agenda-scheduler.e-schedule
  /deep/
  td.e-work-cells.e-parent-node.e-resource-group-cells:hover {
  background: #dddddd;
}
.agenda-scheduler.e-schedule
  /deep/
  td.e-work-cells.e-child-node.e-work-days.e-selected-cell,
.agenda-scheduler.e-schedule
  /deep/
  td.e-work-cells.e-child-node.e-work-days:hover {
  background: #ffffff;
}
.agenda-scheduler.e-schedule /deep/ td.e-work-cells.e-child-node.e-work-days,
.agenda-scheduler.e-schedule /deep/ .e-content-wrap table col {
  min-width: 200px !important;
  /* min-height: 75px !important; */
  /* height: auto !important; */
}

.agenda-scheduler.e-schedule /deep/ .e-appointment {
  max-width: 198px !important;
  left: 0;
  right: 0;
  height: inherit !important;
  background: #fff !important;
  position: relative !important;
  border: none !important;
}
.agenda-scheduler.e-schedule
  /deep/
  .e-timeline-year-view
  .e-event-table
  .e-appointment
  .e-time {
  display: none;
}
.agenda-scheduler.e-schedule /deep/ .e-resource-text {
  margin-left: 0 !important;
  text-overflow: ellipsis;
  white-space: normal;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  font-weight: 500;
}

.agenda-scheduler.e-schedule /deep/ .agendaNameTooltip {
  margin-left: 0 !important;
  text-overflow: ellipsis;
  white-space: normal;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  font-weight: 500;
}

.agenda-scheduler /deep/ .e-resource-column-wrap .e-resource-cells {
  align-items: center;
  display: flex;
}
.agenda-scheduler /deep/.e-resource-tree-icon {
  display: none;
}
.agenda-scheduler /deep/ .e-parent-node.e-resource-group-cells {
  height: 35px;
  background: #dddddd;
  color: #333333;
  border-width: 1px 1px 1px 0;
}
.agenda-scheduler.e-schedule .e-timeline-year-view .e-header-cells {
  min-width: 200px !important;
}

.agenda-scheduler.e-schedule
  .e-timeline-year-view
  .e-event-table
  .e-appointment {
  border: none !important;
  margin: 4px !important;
}
.agenda-scheduler.e-schedule
  .e-timeline-view
  .e-resource-left-td
  .e-resource-text
  > div:last-child {
  border-right: 0;
}

.agenda-scheduler.e-schedule .template-wrap {
  display: flex;
  text-align: left;
}

.agenda-scheduler.e-schedule .template-wrap > div {
  border-right: 1px solid rgba(0, 0, 0, 0.12);
  flex: 0 0 100%;
  font-weight: 500;
  overflow: hidden;
  padding-left: 5px;
  text-overflow: ellipsis;
}

.agenda-scheduler.e-schedule .template-wrap > div:last-child {
  border-right: 0;
}

.agenda-scheduler.e-schedule .e-timeline-year-view .e-content-wrap table td,
.agenda-scheduler.e-schedule .e-timeline-year-view .e-content-wrap table col {
  min-width: 250px !important;
}

.cell-position {
  position: absolute !important;
}
</style>